import { en } from './dictionaries/en';
import { es } from './dictionaries/es';
import { deepMerge } from '../utils/object';

export type LocaleKey = 'en' | 'es';

const dictionaries: Record<LocaleKey, Record<string, any>> = {
  en,
  es,
};

const fallback = 'en';

export function getTranslator(locale: LocaleKey = fallback) {
  const dict = dictionaries[locale] ?? dictionaries[fallback];
  return function t(path: string, replacements?: Record<string, string | number>) {
    const segments = path.split('.');
    let current: any = dict;
    for (const segment of segments) {
      if (current && typeof current === 'object' && segment in current) {
        current = current[segment];
      } else {
        current = path;
        break;
      }
    }
    if (typeof current === 'string' && replacements) {
      return Object.entries(replacements).reduce(
        (acc, [key, value]) => acc.replace(new RegExp(`{{${key}}}`, 'g'), String(value)),
        current,
      );
    }
    return current;
  };
}

export function extendLocale(locale: LocaleKey, entries: Record<string, any>) {
  const base = dictionaries[locale] ?? {};
  dictionaries[locale] = deepMerge(base, entries);
}

export function listLocales(): LocaleKey[] {
  return Object.keys(dictionaries) as LocaleKey[];
}
